import Navigation from "@/components/Navigation";
import FooterMinimal from "@/components/FooterMinimal";
import AnimatedPage from "@/components/AnimatedPage";
import ScrollReveal from "@/components/ScrollReveal";
import CalendlyInlineWidget from "@/components/CalendlyInlineWidget";

const CALENDLY_URL = "https://calendly.com/astreonaigroup/30min?hide_gdpr_banner=1";

const BookDemo = () => {
  return (
    <AnimatedPage>
      <div className="min-h-screen bg-background text-foreground">
        <Navigation />

        <section className="pt-[53px]">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-3 md:pt-3 pb-8">
            <ScrollReveal>
              <p className="text-[12px] font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-5 text-body">
                Book a complimentary audit
              </p>
            </ScrollReveal>
            <ScrollReveal delay={0.06}>
              <h1 className="text-[40px] md:text-[64px] lg:text-[80px] font-normal leading-[0.98] tracking-tight text-foreground max-w-[1000px]">
                Book your <em className="italic font-normal">complimentary</em> strategy session.
              </h1>
            </ScrollReveal>
            <ScrollReveal delay={0.12}>
              <p className="text-[16px] md:text-[18px] text-muted-foreground mt-6 max-w-[620px] leading-[1.6] text-body">
                Pick a time that suits you. We'll explore where AI can move the needle in your business and walk you through what an engagement with Astreon looks like.
              </p>
            </ScrollReveal>
          </div>

          <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10 pb-20 md:pb-28">
            <CalendlyInlineWidget url={CALENDLY_URL} title="Book a strategy session" redirectOnScheduleTo="/booking-confirmed" />
            <p className="text-center text-[13px] text-muted-foreground mt-6 text-body">
              Trouble loading?{" "}
              <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="underline underline-offset-4 hover:text-foreground">
                Open the booking page in a new tab
              </a>
              .
            </p>
          </div>
        </section>

        <FooterMinimal />
      </div>
    </AnimatedPage>
  );
};

export default BookDemo;
